import {
  IconFile,
  IconFileTypeBmp,
  IconFileTypeCsv,
  IconFileTypeDoc,
  IconFileTypeDocx,
  IconFileTypeJpg,
  IconFileTypePdf,
  IconFileTypePng,
  IconFileTypePpt,
  IconFileTypeTxt,
  IconFileTypeXls,
  IconFileTypeZip,
  type TablerIconsProps
} from '@tabler/icons-react'
import { replace } from 'lodash'
import { type FC, useMemo } from 'react'

export interface IconFileTypeProps extends TablerIconsProps {
  fileExt: string
}

export const IconFileType: FC<IconFileTypeProps> = ({ size = 18, fileExt, ...props }) => {
  const Icon = useMemo(() => {
    switch (replace(fileExt, '.', '')) {
      case 'bmp':
      case 'tif':
      case 'tiff':
        return IconFileTypeBmp
      case 'csv':
        return IconFileTypeCsv
      case 'doc':
        return IconFileTypeDoc
      case 'docx':
        return IconFileTypeDocx
      case 'jpg':
      case 'jpeg':
        return IconFileTypeJpg
      case 'pdf':
        return IconFileTypePdf
      case 'png':
        return IconFileTypePng
      case 'ppt':
      case 'pptx':
        return IconFileTypePpt
      case 'rtf':
      case 'txt':
        return IconFileTypeTxt
      case 'xls':
      case 'xlsx':
        return IconFileTypeXls
      case 'zip':
        return IconFileTypeZip
      default:
        return IconFile
    }
  }, [fileExt])

  return (
    <Icon
      size={size}
      {...props}
    />
  )
}
